import { useFormContext } from 'react-hook-form'
import { FormField } from '~/components'
import { StyledRadioGroup, type RadioOption } from './StyledRadioGroup'

export type StyledRadioGroupFieldProps = {
  name: string
  label: string
  options: readonly RadioOption[]
  className?: string
  maxColumns?: number
  required?: boolean
  onValueChange?: (value: string) => void
}

export const StyledRadioGroupField = ({
  name,
  label,
  options,
  className,
  maxColumns = 2,
  required,
  onValueChange: onValueChangeProp,
}: StyledRadioGroupFieldProps) => {
  const form = useFormContext()

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <StyledRadioGroup
          label={label}
          options={options}
          value={field.value}
          onValueChange={(value) => {
            field.onChange(value)
            // Both, never either/or: a caller's handler clears dependent fields,
            // it does not replace revalidation. Skipping the trigger left the
            // "Dieses Feld ist erforderlich" message under a group that was
            // already answered — the form revalidates on blur, which the cards
            // never fire (ticket 86caz2637).
            onValueChangeProp?.(value)
            form.trigger(name)
          }}
          className={className}
          maxColumns={maxColumns}
          required={required}
        />
      )}
    />
  )
}
